import { render, staticRenderFns } from "./DataPesertaDokumen.vue?vue&type=template&id=4d6e6407&"
import script from "./DataPesertaDokumen.vue?vue&type=script&lang=js&"
export * from "./DataPesertaDokumen.vue?vue&type=script&lang=js&"
import style0 from "./DataPesertaDokumen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports